// ======================================================================
// File Name       : NoticeForServiceTop
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Table, Form, Row } from 'react-bootstrap';
import PaginationCustom from '../../components/Pagination';
import Header from '../../components/Header';
import { parseDateForDetail } from '../../utils/index';
import { RETURN_MAX_NUM_TOP } from '../../constants/index';

class NoticeForServiceTop extends React.Component {
  render() {
    const { noticeList, startPositionService, recordNumService, getStartEndDataService } = this.props;
    const noticeForEnterprisePreview = noticeList && noticeList.length > 0 && noticeList.map((noticeForEnterprise, index) =>
      (<tr key={noticeForEnterprise.noticeTitle + index}>
      <td>
        <a role="button" className="" onClick={this.props.onHandleNoticeDetail.bind(this, noticeForEnterprise)}>
          {noticeForEnterprise.noticeTitle}
        </a>
        </td>
        <td>{noticeForEnterprise.authorName}</td>
        <td>{parseDateForDetail(noticeForEnterprise.createdAt)}</td>
      </tr>),
    );
    return (
      <Col>
        <Col sm={12} className="padding-left-clear margin-top-20">
          <Row>
            <Col className="margin-left-15">
              <Header name="サービス向けお知らせ一覧" />
            </Col>
            <Col xs="auto" className="mt-2 margin-top-20">
              <PaginationCustom
                recordNum={recordNumService}
                handlePageSelect={getStartEndDataService}
                startPosition={startPositionService}
                name={'Enterprise'}
                returnMaxNum={RETURN_MAX_NUM_TOP}
              />
            </Col>
          </Row>
          <Table striped hover>
            <thead>
              <tr>
                <th>お知らせ</th>
                <th>登録者</th>
                <th>登録日</th>
              </tr>
            </thead>
            <tbody>
              {noticeForEnterprisePreview}
            </tbody>
          </Table>
        </Col>
      </Col>
    );
  }
}

export default NoticeForServiceTop;
